// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        },
        root: {
          // Custom styles for MuiTypography-root - only apply to body text, not headings
          '&:not(.MuiTypography-h1):not(.MuiTypography-h2):not(.MuiTypography-h3):not(.MuiTypography-h4):not(.MuiTypography-h5):not(.MuiTypography-h6)': {
            fontSize: '0.875rem',
            lineHeight: 1.7
          }
        }
      }
    }
  };
}
